import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-multi-lang';
import { Card, CardBody, CardHeader, Nav, NavItem, NavLink, TabContent, TabPane,
        Modal, ModalHeader, ModalBody, Button, Row, Col, Input, ModalFooter, FormGroup, Label, Form,
        Alert } from 'reactstrap';
import AuthService from '../Services/AuthService';
import VolumesService from '../Services/VolumesService';
import { useToasts } from 'react-toast-notifications';
import { Table, Tr, Td, Thead, Tbody, Th } from 'react-super-responsive-table';
import FileService from '../Services/FileService';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowDown,
    faArrowDownWideShort,
    faArrowUp,
    faArrowUpWideShort, faCamera, faCheck, faMoneyCheckAlt, faPenToSquare, faSync, faTimes, faWeightScale
} from "@fortawesome/free-solid-svg-icons";

const ReAssessment = ({ t }) => {
    const [activeTab, setActiveTab] = useState('1');
    const [user, setUser] = useState({});
    const [volumes, setVolumes] = useState([]);
    const [uploadingForVolume, setUploadingForVolume] = useState({});
    const [managingPhotosModalOpen, setManagingPhotosModalOpen] = useState(false);
    const [activeImage, setActiveImage] = useState('');
    const [seeingImage, setSeeingImage] = useState(false);
    const [search, setSearch] = useState('');
    const [assessmentsModalOpen, setAssessmentsModalOpen] = useState(false);
    const [assessments, setAssessments] = useState([]);
    const [assessment, setAssessment] = useState({
        isReAssessment: true
    });
    const [addingAssessment, setAddingAssessment] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [syncingToErp, setSyncingToErp] = useState(false);

    const volumesService = new VolumesService();
    const fileService = new FileService();

    const selectTab = (tab) => setActiveTab(tab);

    const toggleManagePhotosModalOpen = () => {
        setManagingPhotosModalOpen(!managingPhotosModalOpen);
    }

    const toggleSeeingImage = () => {
        setSeeingImage(!seeingImage);
    }

    const { addToast } = useToasts();

    const getVolumes = () => {
        try{
            volumesService.getReassessable().then(vs => setVolumes(vs));
        } catch(e){ 
            addToast(e)
        }
    };

    useEffect(() => {
        let u = volumesService.authService.getUser();
        setUser(u);
        getVolumes();
    }, []);

    const startReassessment = (volumeId) => {
        volumesService.startReassessment(volumeId).then(r => {
            addToast(t('reassessment.startedReassessment'), {appearance: 'success'});
            getVolumes();
        }).catch(e => {
            addToast(e, {appearance: 'error'});
        });
    };

    const uploadFile = (file) => {
        if(file){
            fileService.uploadFile(file).then(r => {
                addToast(t('volumes.uploadSuccess'), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
                let existingImages = [];
                if(uploadingForVolume.photos){
                    existingImages = JSON.parse(uploadingForVolume.photos);
                }
                existingImages.push(JSON.parse(r)[0]);
                setUploadingForVolume({
                    ...uploadingForVolume,
                    photos: JSON.stringify(existingImages)
                });
            }).catch(e => {
                addToast(t('volumes.uploadError'), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
            });
        }
    };

    const updateUploadedPhotos = () => {
        volumesService.updateVolume(uploadingForVolume).then(r => {
            addToast(t('volumes.photosSavedSuccess'), {appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000});
            toggleManagePhotosModalOpen();
            
        }).catch(e => {
            addToast(t('volumes.photosSavedError'), {appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000});
        });
    };

    const deleteImage = (index) => {
        let images = JSON.parse(uploadingForVolume.photos);
        delete images[index];
        setUploadingForVolume({
            ...uploadingForVolume, 
            photos: JSON.stringify(images.filter(i => i))
        });
    };

    const decideReAssessment = (v) => {
        if(volumesService.authService.getConfig())
            return volumesService.decideReAssessment(v);
    };

    const toggleAssessmentsModalOpen = () => {
        setAssessmentsModalOpen(!assessmentsModalOpen);
    };

    const assessVolume = (v) => {
        if(v.wh !== volumesService.authService.getConfig().whCode){
            addToast(t("volumes.otherQuarryVolume"), {
                appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000
            });
        }
        else{
            setAssessments(v.assessments.filter(a => a.isReAssessment) ? v.assessments.filter(a => a.isReAssessment) : []);
            setAssessment({volumeId: v.volumeId, isReAssessment: true});
            toggleAssessmentsModalOpen();
        }
    };

    const createAssessment = (e) => {
        e.preventDefault();
        setBtnDisabled(true);
        try{
            volumesService.reassess(assessment).then(a => {
                let v = volumes.filter(vol => vol.volumeId === assessment.volumeId)[0];
                if(volumesService.draftAssessments.includes(assessment.assessment) && !v.measurementId){
                    volumesService.addMeasurement({
                        volumeId: v.volumeId,
                        length: 0.1,
                        width: 0.1,
                        depth: 0.1
                    }).then(r => getVolumes());
                }
                getVolumes();
                setAssessment({});
                setAddingAssessment(false);
                toggleAssessmentsModalOpen();
                addToast(t("volumes.assessmentSuccess"), 
                    { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
                setBtnDisabled(false);
            }).catch(e => {
                if(e.error){
                    addToast(e.error, 
                        { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
                }
                else{
                    addToast(t("volumes.assessmentError"), 
                        { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
                }
                setBtnDisabled(false);
            });
        }catch(e){
            addToast(e, 
                    { appearance: 'warning', autoDismiss: true, autoDismissTimeout: 4000 });
            setBtnDisabled(false);
        }
    }

    const syncToErp = (v) => {
        setSyncingToErp(true);
        try{
            volumesService.syncToErpRe(v).then(r => {
                addToast(t('volumes.syncSuccess'), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 3000 });
                getVolumes();
                setSyncingToErp(false);
            }).catch(e => {
                setSyncingToErp(false);
                addToast(t('volumes.syncError'), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 3000 });
            });
        }catch(e){
            setSyncingToErp(false);
            addToast(e, { appearance: 'warning', autoDismiss: true, autoDismissTimeout: 4000 });
        }
    };

    return <>
        <Card>
            <CardHeader className='bg-primary text-white'>
                <h3>{t('sideBar.reassessment')}</h3>
            </CardHeader>
            <CardBody>
                <Nav tabs>
                    <NavItem>
                        <NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => selectTab('1')}>
                            {t('reassessment.availableToReassess')}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => selectTab('2')}>
                            {t('reassessment.reasessing')}
                        </NavLink>
                    </NavItem>
                    {
                        (user.role === 'admin' || user.role === 'manager') && <NavItem>
                            <NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => selectTab('3')}>
                                {t('reassessment.doneReassessing')}
                            </NavLink>
                        </NavItem>
                    }
                    
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId='1'>
                        <h3>{t('reassessment.reassessableVolumes')}</h3>
                        <FormGroup>
                            <Input type="search" onChange={e => setSearch(e.target.value)} placeholder="Search"/>
                        </FormGroup>
                        <Table className="table table-responsive table-striped">
                            <Thead>
                                <Tr>
                                    <Th>{t('volumes.sn')}</Th>
                                    <Th>{t('volumes.quarryLevel')}</Th>
                                    <Th>{t('volumes.date')}</Th>
                                    <Th>{t('volumes.dimensions')}<br />{t('volumes.dimensionBreakdown')}</Th>
                                    <Th>{t('volumes.item')}</Th>
                                    <Th>{t('volumes.assessment')}</Th>
                                    <Th>{t('volumes.weight')}</Th>
                                    <Th className="text-end">{t('volumes.actions')}</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                            {
                                volumes.filter((v) => !v.underReAssessment)
                                .filter(v => v.erpNumber.includes(search) || v.lot.includes(search) || volumesService.getVolumeItem(v).includes(search))
                                .sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{v.measurement.length}/{v.measurement.width}/{v.measurement.depth}</Td>
                                        <Td>
                                            {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)}<br />
                                            {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '21px', fontWeight: 'bold'}}>{v.erpNumber}</span><br />
                                            {t('volumes.lotNumber')}: {v.lot}
                                        </Td>
                                        <Td>
                                            
                                        </Td>
                                        <Td>
                                            <span style={{fontSize: '20px'}} className="text-primary">{v.weight.toLocaleString()}kg</span>
                                        </Td>
                                        <Td className="text-end">
                                            {
                                                v.photos && JSON.parse(v.photos).length > 0 && <Button color="primary"
                                                size="sm" onClick={() => startReassessment(v.volumeId)}>
                                                    <FontAwesomeIcon icon={faSync} />
                                                </Button>
                                            }
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                            </Tbody>
                        </Table>
                    </TabPane>
                    <TabPane tabId='2'>
                        <h3>{t('reassessment.reassessingVolumes')}</h3>
                        <Table className="table table-responsive table-striped">
                            <Thead>
                                <Tr>
                                    <Th>{t('volumes.sn')}</Th>
                                    <Th>{t('volumes.quarryLevel')}</Th>
                                    <Th>{t('volumes.date')}</Th>
                                    <Th>{t('volumes.dimensions')}<br />{t('volumes.dimensionBreakdown')}</Th>
                                    <Th>{t('volumes.item')}</Th>
                                    <Th>{t('volumes.assessment')}</Th>
                                    <Th>{t('volumes.weight')}</Th>
                                    <Th className="text-end">{t('volumes.actions')}</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                            {
                                volumes.filter((v) => v.underReAssessment && !v.completedReassessment)
                                    .sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{v.measurement.length}/{v.measurement.width}/{v.measurement.depth}</Td>
                                        <Td>
                                            {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)}<br />
                                            {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '21px', fontWeight: 'bold'}}>{v.erpNumber}</span><br />
                                            {t('volumes.lotNumber')}: {v.lot}
                                        </Td>
                                        <Td>
                                            {
                                                <Button color="warning" onClick={() => assessVolume(v)}>
                                                    {decideReAssessment(v) || 'Αξιολόγηση'}
                                                </Button>
                                            }
                                        </Td>
                                        <Td>
                                            <span style={{fontSize: '20px'}} className="text-primary">{v.weight.toLocaleString()}kg</span>
                                        </Td>
                                        <Td className="text-end">
                                            {
                                                ['assessor', 'assessor', 'admin'].includes(user.role) && 
                                                    ((v.wh === '49' && v.assessments.filter(a => a.isReAssessment).length === 1) || v.wh !== '49' && v.assessments.filter(a => a.isReAssessment).length === 3)
                                                    && <><Button size="sm" color="warning" onClick={() => syncToErp(v)}><FontAwesomeIcon icon={faSync} /></Button>{" "}</>
                                            }
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                            </Tbody>
                        </Table>
                    </TabPane>
                    <TabPane tabId='3'>
                        <h3>{t('reassessment.doneReassessing')}</h3>
                        <Table className="table table-responsive table-striped">
                            <Thead>
                                <Tr>
                                    <Th>{t('volumes.sn')}</Th>
                                    <Th>{t('volumes.quarryLevel')}</Th>
                                    <Th>{t('volumes.date')}</Th>
                                    <Th>{t('volumes.dimensions')}<br />{t('volumes.dimensionBreakdown')}</Th>
                                    <Th>{t('volumes.item')}</Th>
                                    <Th>{t('volumes.assessment')}</Th>
                                    <Th>{t('volumes.weight')}</Th>
                                    <Th className="text-end">{t('volumes.actions')}</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                            {
                                volumes.filter((v) => v.underReAssessment && v.completedReassessment)
                                    .sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                                    return <Tr key={v.volumeId}>
                                        <Td>{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</Td>
                                        <Td>{v.self}</Td>
                                        <Td>{v.date.split('T')[0].split('-').reverse().join('-')}</Td>
                                        <Td>{v.measurement.length}/{v.measurement.width}/{v.measurement.depth}</Td>
                                        <Td>
                                            {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)}<br />
                                            {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '21px', fontWeight: 'bold'}}>{v.erpNumber}</span><br />
                                            {t('volumes.lotNumber')}: {v.lot}
                                        </Td>
                                        <Td>
                                            {decideReAssessment(v) || 'Αξιολόγηση'}
                                        </Td>
                                        <Td>
                                            <span style={{fontSize: '20px'}} className="text-primary">{v.weight.toLocaleString()}kg</span>
                                        </Td>
                                        <Td className="text-end">
                                            
                                            <Button size="sm" color="warning" onClick={() => {
                                                setUploadingForVolume(v);
                                                toggleManagePhotosModalOpen();
                                            }}> <FontAwesomeIcon icon={faCamera} /> </Button>
                                        </Td>
                                    </Tr>
                                })
                            }
                            </Tbody>
                        </Table>
                    </TabPane>
                </TabContent>
            </CardBody>
        </Card>
        <Modal isOpen={managingPhotosModalOpen} toggle={() => toggleManagePhotosModalOpen} centered size="xl">
            <ModalHeader>
                <h4>{t('volumes.blockPhotos')}</h4>
            </ModalHeader>
            <ModalBody>
                <Input type='file' onChange={(e) => {uploadFile(e.target.files[0])}} placeholder={t('volumes.uploadFilesHere')}/>
                <hr />

                <Row>
                    {
                        uploadingForVolume.photos && JSON.parse(uploadingForVolume.photos).length && JSON.parse(uploadingForVolume.photos).map((p, i) => {
                            return <Col md="3" className='text-center'>
                                {
                                    p && p.type.includes('image') && <><img src={fileService.getUrl(p.name)} alt={fileService.getUrl(p.name)} style={{ width: '95%' }} 
                                        onClick={() => {
                                            setActiveImage(fileService.getUrl(p.name));
                                            toggleSeeingImage();
                                        }}/>
                                        <br />
                                        {
                                            user.role === 'admin' && <Button color='danger' size="sm" onClick={() => deleteImage(i)}><FontAwesomeIcon icon={faTimes} /> {t('volumes.delete')}</Button>
                                        }
                                    </>
                                }
                            </Col>
                        })
                    }
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" size="sm" onClick={updateUploadedPhotos}>{t('volumes.save')}</Button>
                <Button className="ms-auto" color="warning" size="sm" onClick={toggleManagePhotosModalOpen}>{t('volumes.close')}</Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={seeingImage} toggle={toggleSeeingImage} size="xl" centered>
            <ModalBody>
                <img src={activeImage} style={{width: '100%'}} alt="img" />
            </ModalBody>
            <ModalFooter>
                <Button className="ms-auto" color="warning" size="sm" onClick={toggleSeeingImage}>{t('volumes.close')}</Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={assessmentsModalOpen} toggle={toggleAssessmentsModalOpen} centered>
            <ModalHeader>
                <h4>{t('volumes.assessments')}</h4>
            </ModalHeader>
            <ModalBody>
                {
                    ['assessor', 'admin'].includes(user.role) && <>
                        <Table className="table table-responsive table-striped">
                            <Thead>
                            <Tr>
                                {
                                    (user.role === 'admin' || user.role === 'manager') && <Th>{t('volumes.user')}</Th>
                                }
                                <Th>{t('volumes.order')}</Th>
                                <Th>{t('volumes.assessment')}</Th>
                            </Tr>
                            </Thead>
                            <Tbody>
                            {
                                assessments.filter((a) => {
                                    return user.role === 'admin' || user.role === 'manager' || a.userId === user.userId; 
                                }).
                                map((a, i) => {
                                return <Tr key={i}>
                                    {(user.role === 'admin' || user.role === 'manager') && 
                                        <Td>{a.user.name}</Td>
                                    }
                                    <td>{i+1}</td>
                                    <Td>{a.assessment}</Td>
                                </Tr>
                                })
                            }
                            </Tbody>
                        </Table>
                    </>
                }
                {
                    ['admin', 'manager', 'assessor'].includes(user.role) && assessments.filter(a => a.userId === user.userId).length === 0 && <Button
                        color="primary" size="sm" onClick={() => setAddingAssessment(true)}> 
                        {t('volumes.assessment')}
                    </Button>
                }
                {
                    addingAssessment && <Form onSubmit={createAssessment}>
                        <FormGroup>
                            <Label>{t('volumes.assessment')}</Label>
                            <Input type="select" onChange={(e) => {
                                setAssessment({
                                    ...assessment,
                                    assessment: e.target.value
                                });
                            }}>
                                <option value="">{t('volumes.selectAssessment')}</option>
                                {
                                    volumesService.authService.getConfig().products.reduce((assess, p) => {
                                        return assess.concat(p.assessments);
                                    }, []).map((a) => {
                                        return <option value={a}>{a}</option>
                                    })
                                }
                            </Input>
                        </FormGroup>
                        <Button color="primary" disabled={btnDisabled} size="sm">{t('volumes.save')}</Button>
                    </Form>
                }
            </ModalBody>
            <ModalFooter>
                <Button className="ms-auto" color="danger" onClick={toggleAssessmentsModalOpen}>{t('volumes.cancel')}</Button>
            </ModalFooter>
        </Modal>
        <Modal isOpen={syncingToErp} centered>
            <ModalBody>
                <Alert color="info">
                    {t('volumes.syncingBlock')}
                </Alert>
            </ModalBody>
        </Modal>
    </>
}

export default withTranslation(ReAssessment);